import { useEffect } from 'react';
import { useProjectContext } from '~/hooks';
import { 
  ContractType,
  PricingType,
  SiteLeaseTermIntegers, 
} from '~/constants';
import { Project } from '~/types/project';
import { DeploymentTypes } from '~/constants/deployment-type';

export const useDerivedContractFields = () => {
   const { project, updateProjectValue } = useProjectContext();

   useEffect(() => {
      const { deploymentType, contractType, contractTerm, siteLeaseTerm, siteLeaseExtensions, pricingType } = project ?? {};

      const updates = {} as any;

      const queueUpdate = (key: keyof Project, value: any) => {
         if (project[key] !== value) {
            updates[key] = value;
         }
      };

      if (deploymentType === DeploymentTypes.UTILITY && contractType === ContractType.UNCONTRACTED) {
         // Assign the contract term to either the siteLeaseTerm or siteLeaseExtensions (or the sum if both are present)
         if (!siteLeaseTerm && !siteLeaseExtensions && contractTerm) {
            // Handle values entered before selecting 'uncontracted'
            queueUpdate('contractTerm', null);
         } else if (siteLeaseTerm && siteLeaseExtensions) {
            queueUpdate('contractTerm', SiteLeaseTermIntegers[siteLeaseTerm] + siteLeaseExtensions);
         } else {
            queueUpdate('contractTerm', !siteLeaseTerm ? siteLeaseExtensions : SiteLeaseTermIntegers[siteLeaseTerm]);
         }
      }
      
      if (!(deploymentType === DeploymentTypes.UTILITY && (pricingType === PricingType.ACQUISITION || pricingType === PricingType.DEV_FEE)) && contractType === ContractType.UNCONTRACTED) {
         // Reset uncontracted to default if uncontracted was set but is no longer valid
         queueUpdate('contractType', ContractType.PPA);
      }

      // Call updateProjectValue only if something changed
      if (Object.keys(updates).length) {
         updateProjectValue('', updates, { patch: true });
      }
   }, [project?.deploymentType, project?.contractType, project?.siteLeaseTerm, project?.siteLeaseExtensions, project?.pricingType]);
};